// DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
import { Injectable } from '@angular/core';
import { Subject ,  Observable } from 'rxjs';
import { ConstantsService } from '@app/core/services/constants.service';

@Injectable({
  providedIn: 'root'
})
export class SocoConfigurationService {

  // Defining the Constructor
  constructor(private constantsSVC: ConstantsService) { }
    private configurationUpdatedSource = new Subject<string>();
    configurationUpdated = this.configurationUpdatedSource.asObservable();

    public isModified(settingUpdated: string, settingName: string, settingValue: any, shouldAcceptNullValue = false): boolean {
        // if settingUpdated is null then multiple settings were updated
        if (settingUpdated == null || settingUpdated === settingName) {
            const updatedValue = this.getSetting(settingName);
            if ((shouldAcceptNullValue || updatedValue) && updatedValue !== settingValue) {
                return true;
            }
        }
        return false;
    }

    public getSetting<T>(settingName: string): T {
        const config = this.data;
        if (config && config.hasOwnProperty(settingName)) {
            return config[settingName];
        }
        return null;
    }

    get_cookie() {
      if (document.cookie && document.cookie.indexOf(this.constantsSVC.UserCookie) !== -1) {
          return true;
      } else {
          return false;
      }
  }

    public setSetting<T>(settingName: string, settingValue: T) {
        let config = this.data;
        if (!config) {
            config = {};
        }
        config[settingName] = settingValue;
        this.data = config;
        this.configurationUpdatedSource.next(settingName);
    }

    public set settings(value: any) {
        let config = this.data;
        if (!config) {
            config = value;
        } else {
            config = Object.assign(config, value);
        }
        this.data = config;
        this.configurationUpdatedSource.next(null);
    }

    public get webApiBaseUrl(): string {
        const config = this.data;
        if (config) {
            return config.webApiBaseUrl;
        }
        return null;
    }

    public set webApiBaseUrl(value: string) {
        let config = this.data;
        if (!config) {
            config = {};
        }
        config.webApiBaseUrl = value;
        this.data = config;
        this.configurationUpdatedSource.next('webApiBaseUrl');
    }

    public get webApiToken(): string {
      const config = this.data;
      if (config ) {
        return config.webApiToken;

       // Todo: DSS: This code is incompatible with webauth, should likely be removed -- BT 3/20/24
      //  if (config.webApiToken === 'ANONYMOUS') {
       //  return config.webApiToken;
       // } else {
       //   if (this.get_cookie()) {
       //    return config.webApiToken;
       //   } else {
       //   return undefined;
       //   }
       // }
      }
      return undefined;
    }

    public set webApiToken(value: string) {
        let config = this.data;
        if (!config) {
            config = {};
        }
        config.webApiToken = value;
        this.data = config;
        this.configurationUpdatedSource.next('webApiToken');
    }

    public get coolSecurityToken(): string {
        const config = this.data;
        if (config) {
            return config.coolSecurityToken;
        }
        return null;
    }

    public set coolSecurityToken(value: string) {
        let config = this.data;
        if (!config) {
            config = {};
        }
      config.coolSecurityToken = value;
      this.data = config;
      this.configurationUpdatedSource.next('coolSecurityToken');
    }

    private get data(): any {
       // tslint:disable-next-line: no-useless-cast
       const configStr = (document.querySelector('.soco-configuration') as HTMLElement).dataset.sococonfiguration;
      if (configStr === undefined) {
          return undefined;
      }
      return JSON.parse(configStr).data;
    }

    private set data(value: any) {
      // tslint:disable-next-line: no-useless-cast
      (document.querySelector('.soco-configuration') as HTMLElement).dataset.sococonfiguration = JSON.stringify({ data: value });
    }
    public get gisUrl(): string {
        const config = this.data;
        if (config) {
            return config.GisUrl;
        }
        return null;
    }
    public get gisBaseUrl(): string {
        const config = this.data;
        if (config) {
            return config.GisBaseUrl;
        }
        return null;
    }
    public get builderFirstUrl(): string {
        const config = this.data;
        if (config) {
            return config.BuilderFirstUrl;
        }
        return null;
    }
    public get isSoCoEnv(): string {
        const config = this.data;
        if (config) {
            return config.isSoCoEnv;
        }
        return 'true';
    }
}
